import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'ramda';
import { ThemeProvider } from 'styled-components';

import { Container, CheckBox, Check, Text } from './checkbox.styles';

export class CheckboxComponent extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.any,
    error: PropTypes.object,
    name: PropTypes.string.isRequired,
    touched: PropTypes.bool,
    value: PropTypes.bool.isRequired,
    withoutPropagation: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    withoutPropagation: false,
  };

  handleClick = e => {
    if (this.props.withoutPropagation) {
      e.stopPropagation();
    }

    this.props.onChange({ target: { name: this.props.name, value: !this.props.value } });
  };

  render() {
    return (
      <ThemeProvider theme={{ isChecked: this.props.value, hasError: !!this.props.error && this.props.touched }}>
        <Container onClick={this.handleClick} className={this.props.className}>
          <CheckBox>
            <Check />
          </CheckBox>
          <Text>{this.props.children}</Text>
        </Container>
      </ThemeProvider>
    );
  }
}

export const Checkbox = compose(injectIntl)(CheckboxComponent);
